import { showNotification } from "components/v2/notification/notification";
import { RELEASE_HASH } from "config/envConfig";
import { APP_VERSION } from "constants/v2/appConstants";
import { logoutUser } from "containers/app/utils";
import amplitude from "externals/amplitude";
import { getInternalDataDogContext } from "externals/datadog";
import React, { useCallback } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import { sendErrorReport } from "store/common/action";
import { selectSelectedEntityId } from "store/entity/selectors";
import { selectAppAdditionalPermissionsAccountRestrictionBySelectedUserId } from "store/entityConfig/selectors";
import { removeIp } from "store/user/actions";
import { selectSelectedUserId } from "store/user/selectors";
import LocalStorage from "utils/LocalStorage";

import SVGIcon from "../../../Images/SVGIcon";
import commonStyles from "../../../style.module.css";
import styles from "./style.module.css";

const ErrorContent = ({
  title = "Unexpected Error",
  subtitle = "We're having trouble loading this page. Please try refreshing or come back later.",
  isSendErrorReportVisible = true,
  userId,
  entityId,
  sendErrorReport,
  isAccountRestrictionEnabled,
  removeIp,
}) => {
  const navigate = useNavigate();
  const onHomeClick = useCallback(async () => {
    try {
      if (isAccountRestrictionEnabled) {
        amplitude.logEvent("error_fallback_logout_btn_clicked", { version: APP_VERSION.V2 });
        await removeIp({
          payload: {
            userId,
            ipToken: LocalStorage.getItem("authToken"),
            opsEmail: LocalStorage.getItem("opsEmail") ? LocalStorage.getItem("opsEmail") : undefined,
          },
        });
        logoutUser(navigate);
      } else {
        window.location.href = "/";
      }
    } catch (error) {
      console.error(error);
    }
  }, [isAccountRestrictionEnabled, navigate, removeIp, userId]);

  const onReloadClick = useCallback(() => {
    try {
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handleSendErrorreport = async () => {
    try {
      const dataDogSessionId = getInternalDataDogContext()?.session_id;
      const payload = {
        userId,
        entityId,
        location: window.location.href.toString(),
        error: title?.toString() || "",
        stack: subtitle?.toString() || "",
        createdAt: new Date(),
        ...(dataDogSessionId
          ? {
              sessionId: dataDogSessionId,
              DatadogSession: dataDogSessionId
                ? `https://app.datadoghq.eu/rum/replay/sessions/${dataDogSessionId}`
                : "",
            }
          : {}),
        Release: RELEASE_HASH || "",
      };
      const repsonse = await sendErrorReport({ payload });
      if (repsonse?.payload?.data?.success) {
        showNotification({ type: "success", message: repsonse?.payload?.data?.message });
      }
      window.location.href = "/";
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
      <div className={styles.primaryActions}>
        {!isAccountRestrictionEnabled ? (
          <button className={commonStyles.secondaryButton} onClick={onReloadClick}>
            <SVGIcon src="components/v2/ErrorFallbackComponent/ErrorComponent/ErrorContent/refresh.svg" />
            <div>Reload</div>
          </button>
        ) : null}

        <button className={commonStyles.primaryButton} onClick={onHomeClick}>
          {!isAccountRestrictionEnabled ? "Home" : "Logout"}
        </button>
      </div>
      {!isAccountRestrictionEnabled ? (
        <>
          {isSendErrorReportVisible ? (
            <button className={styles.secondaryAction} onClick={handleSendErrorreport}>
              Send error report
            </button>
          ) : null}
          <div className={styles.secondaryActionNoDecoration}>
            Session Id: {getInternalDataDogContext()?.session_id}
          </div>
        </>
      ) : null}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  userId: selectSelectedUserId,
  entityId: selectSelectedEntityId,
  isAccountRestrictionEnabled: selectAppAdditionalPermissionsAccountRestrictionBySelectedUserId,
});

const mapDispatchToProps = { sendErrorReport, removeIp };

export default connect(mapStateToProps, mapDispatchToProps)(ErrorContent);
